import React from "react";
import Home from "./Pages/home";
import About from "./Pages/about";
import "./Pages/styles/styles.css";
import Login from "./Pages/login";
import Navbar from "./Pages/navbar";
import Products from "./Pages/products";
import SingleProduct from "./Pages/singleProduct";
import Error from "./Pages/error";
import Dashboard from "./Pages/dashboard";
import Cart from "./Pages/cart";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Payments from "./Pages/payments";
import Footer from "./Pages/footer";
import FeaturedProducts from "./Pages/upcoming detail";
import WishList from "./Pages/wishlist";
import SignUp from "./Pages/signUP";
import BusinessAccount from "./Pages/businessAccount";
import Help from "./Pages/help";
import Upcoming from "./Pages/upcoming";
import Shipped from "./Pages/shipped";
import List from "./Pages/list";
import ProtectedRoute from "./Pages/protectedRoute";
import ProtectPayments from "./Pages/protectPayments";
function App() {
  const [added, setAdded] = React.useState([]);
  const [user, setUser] = React.useState({ name: "", email: "" });
  const [total, setTotal] = React.useState(0);
  const [wishlist, setWishlist] = React.useState([]);
  const [paymentDetails, setPaymentDetails] = React.useState("");
  const [productId, setProductId] = React.useState();
  const [shipItem, setShipItem] = React.useState({});
  const handleAdded = (e) => {
    setAdded([...added, e]);
  };
  const handleWishlist = (e) => {
    setWishlist([...wishlist, e]);
  };
  const handleCart = (e) => {
    setAdded([...added, e]);
  };
  const handleTotal = (e, id) => {
    setTotal(e.toFixed(2));
    setProductId(id);
  };
  const handleShippedItem = (item) => {
    setShipItem(item);
  };
  const handleRemove = (e) => {
    const newAdded = added.filter((p) => e.id !== p.id);
    setAdded(newAdded);
  };
  const removeFromWishlist = (e) => {
    const newWishList = wishlist.filter((p) => e.id !== p.id);
    setWishlist(newWishList);
  };
  const handleShipped = (e) => {
    setPaymentDetails(e);
  };
  const handleUser = (e) => {
    setUser({ ...user, name: e });
  };
  const handleUserEmail = (email) => {
    return setUser({ ...user, email: email });
  };
  return (
    <BrowserRouter className="App">
      <Navbar counter={added.length} />
      <Routes>
        <Route path="" element={<Home handleAdded={handleAdded} />} />
        <Route path="about" element={<About />} />
        <Route path="login" element={<Login setEmail={handleUserEmail} />} />
        <Route
          path="products"
          element={
            <Products
              handleCart={handleCart}
              handleWishlist={handleWishlist}
              setTotal={handleTotal}
            />
          }
        />
        <Route path="mylist" element={<List />} />
        <Route
          path="upcoming"
          element={
            <Upcoming
              setTotal={handleTotal}
              handleCart={handleCart}
              handleWishlist={handleWishlist}
            />
          }
        />
        <Route path="help" element={<Help />} />
        <Route
          path="upcoming/:productId"
          element={
            <FeaturedProducts
              handleAdded={handleAdded}
              handlePrice={handleTotal}
            />
          }
        />
        <Route
          path="/shipped"
          element={<Shipped name={paymentDetails} shippedItem={shipItem} />}
        />
        <Route
          path="products/:productId"
          element={
            <SingleProduct
              handleAdded={handleAdded}
              handlePrice={handleTotal}
            />
          }
        />
        <Route
          path="cart"
          element={
            <Cart
              addedItems={added}
              setTotal={handleTotal}
              handleRemove={handleRemove}
            />
          }
        />
        <Route path="signup" element={<SignUp setValues={handleUser} />} />
        <Route path="businessaccount" element={<BusinessAccount />} />
        <Route
          path="dashboard"
          element={
            <ProtectedRoute user={user}>
              <Dashboard user={user} />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Error />} />
        <Route
          path="payments"
          element={
            <ProtectPayments itemId={productId}>
              <Payments
                total={total}
                handlePayment={handleShipped}
                itemId={productId}
                payedItem={handleShippedItem}
              />
            </ProtectPayments>
          }
        />
        <Route
          path="/wishlist"
          element={
            <WishList
              list={wishlist}
              setTotal={handleTotal}
              handleRemove={removeFromWishlist}
            />
          }
        />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
